import Chip, { type ChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';

/**
 * Card-brand badge for the cards surface (AUT-126). Renders the brand label
 * as a coloured chip alongside the masked PAN tail. Colours mirror the
 * mockup: Visa → info (blue), Mastercard → warning (amber); any other brand
 * (БЕЛКАРТ, future networks) renders neutral so a new brand added by the
 * acquirer needs no wire/enum change.
 *
 * `brand` is typed `string` on the wire for forward-compat. The label is the
 * server-provided value as-is (it is NOT PII — never a card number).
 */
const KNOWN_BRAND_COLOR: Record<string, ChipProps['color']> = {
  visa: 'info',
  mastercard: 'warning',
};

export const CardBrandBadge = ({ brand }: { brand: string }): ReactElement => {
  const color = KNOWN_BRAND_COLOR[brand.toLowerCase()] ?? 'default';
  return <Chip size="small" color={color} variant="outlined" label={brand} />;
};
